module.exports = __webpack_public_path__ + "static/media/nonord-c-7.4a0a7862.mp3";